export enum HorizonButtonVariant {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    CTA = 'cta',
}

export enum HorizonButtonTone {
    Interactive = 'interactive',
    Brand = 'brand',
    Critical = 'critical',
    Inverse = 'inverse',
}

export enum HorizonAlertTone {
    Caution = 'caution',
    Critical = 'critical',
    Flagged = 'flagged',
    Info = 'info',
    Neutral = 'neutral',
    Positive = 'positive',
}
